import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import useCalendarStore from '../../../store/calendar/useCalendarStore';
import useCalendarSyncPolling from '../../hooks/useCalendarSyncPolling';
import { injectIntl } from 'react-intl';
import { SyncStatus } from '../../util/syncStatus';
import { fetchCalendarEvents, selectDate } from '../../../../app-main/actions/calendar';
import moment from 'moment/moment';

/**
 * Temporary side-effect component to handle calendar sync polling and event updates.
 *
 * This component exists as a bridge during the migration from Redux to Zustand.
 * It handles the dispatch of calendar events and updates while the larger calendar-main
 * refactor is in progress.
 *
 * TODO: Move the calendar event dispatch logic into the useCalendarSyncPolling hook
 * once calendar events are migrated to the Zustand store. This component can then be removed
 * as the hook will handle all sync-related side effects.
 *
 * @deprecated This is a temporary solution during the Redux to Zustand migration
 */
const SyncPollingHandler = ({
  dispatch,
  intl
}) => {
  const syncStatus = useCalendarStore(state => state.syncStatus);
  const selectedSpaceId = useCalendarStore(state => state.selectedSpaceId);

  const onSyncPollingCompleted = () => {
    const accessToken = window.PSSessions.Cookies('PSAccess');

    const params = new URLSearchParams(window.location.search);
    const dateParam = params.get('date');
    const date = dateParam ? moment(dateParam, 'YYYY-MM-DD', true).toDate() : new Date();

    dispatch(fetchCalendarEvents(selectedSpaceId, date, accessToken, (date) => {
      dispatch(selectDate(date));
    }, intl));
  };

  const {
    startCalendarSyncPolling,
    stopCalendarSyncPolling
  } = useCalendarSyncPolling(onSyncPollingCompleted);

  useEffect(() => {
    if (syncStatus === SyncStatus.SYNCING) {
      startCalendarSyncPolling();
    }
    return () => {
      stopCalendarSyncPolling();
    };
  }, [syncStatus]);

  return null;
};

SyncPollingHandler.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default injectIntl(connect()(SyncPollingHandler));
